import { render, staticRenderFns } from "./Portfolio.vue?vue&type=template&id=2c18915c&scoped=true"
import script from "./Portfolio.vue?vue&type=script&lang=js"
export * from "./Portfolio.vue?vue&type=script&lang=js"
import style0 from "./Portfolio.vue?vue&type=style&index=0&id=2c18915c&prod&lang=scss&scoped=true"
import style1 from "./Portfolio.vue?vue&type=style&index=1&id=2c18915c&prod&lang=scss"
import style2 from "./Portfolio.vue?vue&type=style&index=2&id=2c18915c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c18915c",
  null
  
)

export default component.exports